export enum IconLabel {
  PROMOTION = 'ad-label',
  VIRTUAL_BUNDLE = 'virtual-bundling',
}

export interface Props {
  title: string
  subtitle?: string
  iconName: IconLabel
}
